import { IonContent } from "@ionic/react";
function CounterError() {
  return (
    <IonContent placeholder={undefined}>
      <div className="counter-error-wrap">
        <svg
          width="307"
          height="307"
          viewBox="0 0 307 307"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M153.5 291C229.439 291 291 229.439 291 153.5C291 77.5608 229.439 16 153.5 16C77.5608 16 16 77.5608 16 153.5C16 229.439 77.5608 291 153.5 291Z"
            fill="white"
            stroke="#F8993A"
            strokeWidth="30.5556"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M152.739 206.211H154.267V207.739H152.739V206.211Z"
            stroke="#F8993A"
            strokeWidth="30.5556"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M153.5 99.2669V160.378"
            stroke="#F8993A"
            strokeWidth="30.5556"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <h3>Leave arm raised for a full 3 seconds to begin the assessment.</h3>
      </div>
    </IonContent>
  );
}
export default CounterError;
